module.exports = __webpack_public_path__ + "img/Business Person 2.a42e202e.jpg";